/** @jsxImportSource @emotion/react */

import { FC, useCallback, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import packageJson from 'package.alias.json'
import { routes } from 'routes/cmsRoutes'
import { isApiVersionMatch } from 'utils/isApiVersionMatch'
import { CHECK_VERSION } from 'queries/checkVersion'
import { checkVersion } from '__generatedTypes__/checkVersion'
import { ReactComponent as MaintenanceIcon } from './icons/maintenance.svg'
import * as classes from './styles'

const CHECK_API_VERSION_DELAY = 30 * 1000

export const Maintenance: FC = () => {
  const [getActualVersion] = useLazyQuery<checkVersion>(CHECK_VERSION, {
    fetchPolicy: 'network-only',
  })

  const checkVersion = useCallback(async () => {
    try {
      const { data } = await getActualVersion()
      const actualApiVersion = data?.checkVersion.newVersion ?? ''

      if (isApiVersionMatch(actualApiVersion, packageJson.expectedMinApiVersion, packageJson.expectedMaxApiVersion)) {
        location.replace(routes.ROOT)
        return
      }
    } catch (e) {
      console.error('Error:', e)
    }

    setTimeout(() => location.reload(), CHECK_API_VERSION_DELAY)
  }, [])

  useEffect(() => {
    checkVersion()
  }, [])

  return (
    <div css={classes.wrapper}>
      <MaintenanceIcon css={classes.icon} />
      <div css={classes.title}>We&apos;re just tuning up a few things</div>
      <div css={classes.description}>
        We apologize for the inconvenience but the website is currently undergoing planned maintenance. The site should
        be back within an&nbsp;hour!
      </div>
    </div>
  )
}
